import styled from 'styled-components'

export const LoginContainer = styled.main`
  box-sizing: border-box;
  min-height: 100vh;
  padding-bottom: 20%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`
